(function () {
  function initLightbox(root) {
    var lb = root.querySelector("[data-dr-lightbox]");
    if (!lb) return;
    var img = lb.querySelector("img");
    var closeBtn = lb.querySelector("[data-dr-lightbox-close]");

    function open(src, alt) {
      if (!img) return;
      img.src = src;
      img.alt = alt || "Foto de reseña";
      lb.classList.add("is-open");
      lb.setAttribute("aria-hidden", "false");
    }

    function close() {
      lb.classList.remove("is-open");
      lb.setAttribute("aria-hidden", "true");
      if (img) img.removeAttribute("src");
    }

    root.querySelectorAll("[data-dr-photo]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        open(btn.getAttribute("data-dr-photo"), btn.getAttribute("data-dr-alt") || "");
      });
    });

    if (closeBtn) closeBtn.addEventListener("click", close);
    lb.addEventListener("click", function (e) {
      if (e.target === lb) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && lb.classList.contains("is-open")) close();
    });
  }

  function updateMoreCount(root, btn) {
    var countEl = btn.querySelector("[data-dr-more-count]");
    var remaining = root.querySelectorAll("[data-dr-card][hidden], [data-dr-card].is-collapsed").length;
    // after revealing, hidden ones are those still collapsed
    remaining = root.querySelectorAll("[data-dr-card][hidden]").length;
    if (countEl) {
      countEl.textContent = remaining > 0 ? "(" + remaining + " más)" : "";
    }
    if (remaining === 0) {
      btn.hidden = true;
    }
  }

  function initLoadMore(root) {
    var btn = root.querySelector("[data-dr-load-more]");
    if (!btn) return;
    var step = parseInt(root.getAttribute("data-dr-step") || "5", 10);
    if (!step || step < 1) step = 5;

    btn.addEventListener("click", function () {
      var hidden = root.querySelectorAll("[data-dr-card][hidden]");
      var n = 0;
      for (var i = 0; i < hidden.length && n < step; i++) {
        hidden[i].hidden = false;
        hidden[i].classList.remove("is-collapsed");
        n++;
      }
      updateMoreCount(root, btn);
    });

    updateMoreCount(root, btn);
  }

  function initForm(root) {
    var form = root.querySelector("[data-dr-form]");
    if (!form) return;
    var endpoint = form.getAttribute("data-dr-endpoint") || "";
    var msg = root.querySelector("[data-dr-form-msg]");
    var submit = form.querySelector('[type="submit"]');

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      if (!endpoint || endpoint.indexOf("http") !== 0) {
        if (msg) {
          msg.textContent =
            "El envío de reseñas estará activo cuando configuremos la API. Mientras, escríbenos por WhatsApp o Instagram.";
          msg.className = "diminova-reviews__form-msg is-err";
        }
        return;
      }

      var hp = form.querySelector('[name="website"]');
      if (hp && hp.value) return;

      if (msg) {
        msg.textContent = "Enviando…";
        msg.className = "diminova-reviews__form-msg";
      }
      if (submit) submit.disabled = true;

      try {
        var fd = new FormData(form);
        var res = await fetch(endpoint, {
          method: "POST",
          body: fd,
          headers: { Accept: "application/json" },
        });
        var data = {};
        try {
          data = await res.json();
        } catch (_) {}
        if (!res.ok || data.ok === false) {
          throw new Error(data.error || "No se pudo enviar la reseña.");
        }
        form.reset();
        if (msg) {
          msg.textContent = "¡Gracias! Tu reseña quedó pendiente de moderación.";
          msg.className = "diminova-reviews__form-msg is-ok";
        }
      } catch (err) {
        if (msg) {
          msg.textContent = err.message || "Error al enviar.";
          msg.className = "diminova-reviews__form-msg is-err";
        }
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  }

  function boot() {
    document.querySelectorAll("[data-diminova-reviews]").forEach(function (root) {
      initLightbox(root);
      initLoadMore(root);
      initForm(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
